<div *ngIf="entities.length > 0; else emptyEntities">
  <div class="row">
    <div class="col-md-12">
      <fieldset class="form-group">
        <legend class="sr-only">Select agency</legend>
        <div class="select-entity" *ngIf="entities.length > 1">
          <label *ngFor="let entity of entities" class="c-radio p-2">
            <input
              name="entity"
              type="radio"
              aria-label="{{ entity.code }} - {{ entity.name }}"
              value="{{ entity.code }}"
              (change)="handleChange($event, entity)"
              [checked]="entity?.code === current?.code"
            />
            <span class="fa fa-check"></span>
            {{ entity.code }} - {{ entity.name }}
          </label>
        </div>
        <div class="select-entity" *ngIf="entities.length == 1">
          <p class="mb-0" *ngFor="let entity of entities">
            {{ entity.code }} - {{ entity.name }}
          </p>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 text-right">
      <button
        type="button"
        [disabled]="!selectedEntity"
        class="btn btn-sm btn-success ml-2"
        (click)="confirm()"
      >
        Confirm
      </button>
    </div>
  </div>
</div>
<ng-template #emptyEntities>
  <p class="mb-2">You do not have assigned issuing entities</p>
  <div class="row">
    <div class="col-md-12 text-right">
      <button
        type="button"
        class="btn btn-sm btn-primary ml-2"
        (click)="logout()"
      >
        Logout
      </button>
    </div>
  </div>
</ng-template>
